var map = {
	"./add.svg": [
		5382,
		382
	],
	"./arrow-left.svg": [
		6125,
		351
	],
	"./arrow-right.svg": [
		277,
		351
	],
	"./download.svg": [
		7611,
		351
	],
	"./search.svg": [
		3508,
		508
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2632;
module.exports = webpackAsyncContext;